import moment from '../lib/moment-ptbr';

function moneyFilter(raw) {
  if (raw !== 0 && !raw) return '-';
  if (typeof raw !== 'number') return raw;
  return raw.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}

function interestRateFilter(raw) {
  if (typeof raw !== 'number') return raw;
  return `${(raw * 100).toFixed(2).replace('.', ',')}%`;
}

function floatFilter(raw) {
  if (typeof raw !== 'number') return raw;
  return raw.toFixed(2).replace('.', ',').replace(' ', '');
}

function phoneFilter(raw) {
  return `(${raw.substring(0, 2)}) ${raw.substring(2, 7)}-${raw.substring(7)}`;
}

function phoneMask(phone, { lastDigits } = {}) {
  if (!phone) return phone;

  if (lastDigits) return `(${phone.substring(0, 2)}) *****-${phone.substring(7, 11)}`;

  return `(${phone.substring(0, 2)}) ${phone.substring(2, 5)}**-**${phone.substring(9, 11)}`;
}

function cpfFilter(raw) {
  return `${raw.substring(0, 3)}.${raw.substring(3, 6)}.${raw.substring(6, 9)}-${raw.substring(9)}`;
}

function capitalize(s, opt = {}) {
  if (typeof s !== 'string') return '';
  const res = s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  if (!opt.first) return res;
  return res.split(' ')[0];
}

function maxNameFilter(raw) {
  if (typeof raw !== 'string' || raw.length <= 40) return raw;
  return `${raw.substring(0, 41)}...`;
}

function zipCodeFilter(raw) {
  if (!raw || typeof raw !== 'string' || raw.length !== 8) return raw;
  return `${raw.substring(0, 5)}-${raw.substring(5)}`;
}

function dateFilter(raw) {
  if (!raw || typeof raw !== 'string') return raw;
  return moment(raw).format('DD/MM/YYYY');
}

function barcodeFilter(raw) {
  if (!raw || typeof raw !== 'string') return raw;
  return `${raw.substring(0, 5)}.${raw.substring(5, 10)}
  ${raw.substring(10, 15)}.${raw.substring(15, 21)} ${raw
  .substring(21, 26)}.${raw.substring(26, 32)} ${raw
  .substring(32, 33)} ${raw.substring(33, raw.length)}`;
}

function leadZeroFilter(raw) {
  if (!raw || typeof raw !== 'number' || raw < 1 || raw > 9) return raw;
  return `0${raw}`;
}

function capitalizeInSpaces(raw) {
  if (typeof raw !== 'string') return raw;
  return raw
    .split(' ')
    .map((el) => capitalize(el))
    .join(' ');
}
export default {
  methods: {
    moneyFilter,
    floatFilter,
    interestRateFilter,
    capitalize,
    phoneFilter,
    phoneMask,
    cpfFilter,
    maxNameFilter,
    zipCodeFilter,
    dateFilter,
    barcodeFilter,
    leadZeroFilter,
    capitalizeInSpaces,
  },
  filters: {
    moneyFilter,
    floatFilter,
    interestRateFilter,
    capitalize,
    phoneFilter,
    phoneMask,
    cpfFilter,
    maxNameFilter,
    zipCodeFilter,
    dateFilter,
    barcodeFilter,
    leadZeroFilter,
    capitalizeInSpaces,
  },
};
